import CardProject from '../../components/items/CardProject'

import utilities from '../../img/projects/utilities.jpg'
import react from '../../img/technology/react.png'
import html from '../../img/technology/html.png'
import css from '../../img/technology/css.png'
import javaScript from '../../img/technology/javascript.png'

export default function Project4() {
  return (
    <div>
      <CardProject
        name="App-Utilities"
        img={utilities}
        text="O AppUtilities, uma aplicação desenvolvida em Next.js que oferece uma variedade de utilidades diárias, incluindo calculadora, cálculo do Índice de Massa Corporal (IMC) e timer, tudo em um layout responsivo e acessível. Com animações suaves e interativas, o AppUtilities proporciona uma experiência de usuário aprimorada, facilitando as tarefas cotidianas e tornando-as mais eficientes para todos os usuários."
        app="https://app-utilities.vercel.app/"
        repo="https://github.com/RiccettoDev/app-utilities"
        technology1={react}
        nameTechnology1="React JS"
        technology2={html}
        nameTechnology2="HTML"
        technology3={css}
        nameTechnology3="CSS"
        technology4={javaScript}
        nameTechnology4="JavaScript"
      />
    </div>
  )
}
